const ArchivePage = () => {
	return (
		<h1>Archive</h1>
	);
}

export default ArchivePage;